import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'
import { CardActionArea, CardActions } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { CustomModalContext } from 'common/contexts/CustomModalContext'
import { ModalTypes } from 'common/hooks/useCustomModal'
import { useContext, useEffect, useState } from 'react'
import { puedeConsultar, puedeInsertar } from '../libs/PermisosHelper'
import { ExpedientesContext } from '../providers/ExpedientesProvider'
import ListadoExpedientes from './ListadoExpedientes'

export default function MenuExpedientes() {
  const { handleModal } = useContext(CustomModalContext)
  const {
    tipos_expedientes,
    active: { current, setCurrent, forceRefresh },
    setAltaExpediente,
    setOrigen,
  } = useContext(ExpedientesContext)

  const [tiposExpedienteMenu, setTiposExpedienteMenu] = useState()

  useEffect(() => {
    setOrigen('menuExpedientes')
  }, [])

  useEffect(() => {
    handleModal({ enabled: tipos_expedientes?.loading, type: ModalTypes.Loading })
  }, [tipos_expedientes?.loading])

  function buildTree(menuItems) {
    const menuTiposMap = {}
    const tree = []
    menuItems.forEach((item) => {
      menuTiposMap[item.tipo_expediente] = { ...item }
    })

    menuItems.forEach((item) => {
      tree.push(menuTiposMap[item.tipo_expediente])
    })

    return tree
  }

  useEffect(() => {
    if (!tipos_expedientes.response) return
    setTiposExpedienteMenu(buildTree(tipos_expedientes.response?.expedientes))
  }, [tipos_expedientes.response])

  const handleClick = (e) => {
    const menuItem = e.currentTarget.dataset.menuItem
    const tipo_expediente = tiposExpedienteMenu[menuItem]

    if (puedeConsultar(tipo_expediente)) {
      setCurrent(tipo_expediente)
      forceRefresh()
    }
  }

  const handleNuevoExpediente = (e) => {
    const menuItem = e.currentTarget.dataset.menuItem
    const tipo_expediente = tiposExpedienteMenu[menuItem]

    setCurrent(tipo_expediente)
    setAltaExpediente(true)
  }

  return (
    <Box key="expedientes" sx={{ flexGrow: 1 }}>
      {current ? (
        <ListadoExpedientes></ListadoExpedientes>
      ) : !tipos_expedientes?.loading ? (
        <Grid container spacing={2}>
          {tiposExpedienteMenu?.map((item, id) => {
            return (
              <Grid key={id} size={{ xs: 12, sm: 6, md: 3 }}>
                <Card sx={{ height: '100%' }}>
                  <CardActionArea data-menu-item={id} onClick={handleClick}>
                    <CardContent>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 'normal' }}>
                          {item.nombre}
                        </Typography>
                      </Box>
                    </CardContent>
                  </CardActionArea>
                  <CardActions sx={{ justifyContent: 'flex-end' }}>
                    {puedeConsultar(item) && (
                      <Button
                        startIcon={<FormatListBulletedIcon color="info" />}
                        data-menu-item={id}
                        onClick={handleClick}
                      >
                        Consultar
                      </Button>
                    )}
                    {puedeInsertar(item) && (
                      <Button
                        startIcon={<AddCircleRoundedIcon color="warning" />}
                        data-menu-item={id}
                        onClick={handleNuevoExpediente}
                      >
                        Nuevo
                      </Button>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      ) : (
        <Grid container spacing={2}>
          {[...Array(12).keys()].map((id, index) => {
            return (
              <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
                <Card key={id}>
                  <CardActionArea data-menu-item={id} onClick={handleClick}>
                    <CardContent>
                      <Box>
                        <Skeleton
                          variant="rounded"
                          animation="wave"
                          height={24}
                          sx={{ width: '75%' }}
                        />
                      </Box>
                    </CardContent>
                  </CardActionArea>
                  <CardActions sx={{ justifyContent: 'flex-end' }}>
                    <Skeleton variant="circular" height={24} width={24} />
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      )}
    </Box>
  )
}
